/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-destructuring */

import axios from 'axios';
import { apiUrlBase } from '../../api.js';

const moment = require('moment');

moment().format();

const state = {
  all: [],
  jobs: [],
};

const getters = {
};

const actions = {

  importStaffsList({ state, commit }, [estaId, formList]) {
    return new Promise((resolve, reject) => {
      formList.append('esta_id', estaId);
      axios.post(`${apiUrlBase}/internal/ImportStaffList`,
        formList,
        {
          headers:
            {
              'Content-type': 'multipart/form-data',
            },
        })
        .then((response) => {
          const data = response.data;
          //commit('addStaffList', response.data);
          resolve(response);
        })
        .catch((err) => {
          console.log(err);
          reject(err.response.data);
        });
    });
  },
};

const mutations = {

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
